'use client';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Icon } from '@ravago/shared/radiance/components/icon/components/Icon/Icon';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

export const EstimatedDelivery = ({ hasMtsLocal, justify = 'center' }: { hasMtsLocal: boolean; justify?: 'center' | 'start' }) => {
   const translate = useTranslations();

   return (
      <Box justify={justify} gap="xs">
         <Icon icon="truck" size="small" color="subtle" />
         <Typography variant="small" color="subtle">
            {translate('my-orders.estimated-delivery')}
         </Typography>
         <Typography variant="small">
            {translate(hasMtsLocal ? 'request-for-quotation.lead-time.mts-local-days' : 'request-for-quotation.lead-time.delivery-on-request')}
         </Typography>
      </Box>
   );
};
